import { createFileRoute, redirect } from '@tanstack/react-router'
import FirstSubmittalPage from '@/features/city-clerk/first-submital/pages/FirstSubmittalPage/FirstSubmittalPage'
import { useNavigationStore } from '@/stores/useNavigationStore'
// import NewFirstSubmittalPage from '@/features/city-clerk/first-submital/pages/NewFirstSubmittalPage'

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/first-submital/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.firstSubmittalView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      from:
        (search.from as
          | 'administrative-check'
          | 'overall-permits'
          | 'permit-tracking') || undefined,
    }
  },
})

function RouteComponent() {
  const from = useNavigationStore((state) => state.from)
  return <FirstSubmittalPage from={from} />
  // return <NewFirstSubmittalPage />
}
